import { styled } from 'parkdepot-shared/theme'

const NextButtonContainer = styled('div', ({ $theme }) => ({
    width: '100%',

    [$theme.mediaQuery.large]: {
        width: '480px',
        left: '50%',
        transform: 'translateX(-50%)',
        position: 'absolute'
    }
}))

export default NextButtonContainer
